import { render, staticRenderFns } from "./ipWhitelistingAdd.vue?vue&type=template&id=7b2b4e10&"
import script from "./ipWhitelistingAdd.vue?vue&type=script&lang=js&"
export * from "./ipWhitelistingAdd.vue?vue&type=script&lang=js&"
import style0 from "./ipWhitelistingAdd.vue?vue&type=style&index=0&id=7b2b4e10&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports